export const CandidateListEnglish = {
  title: 'Candidates',
  published: 'Published',
  drafted: 'Draft',
  closed: 'Closed',
  activeCount: 'Active',
  archiveCount: 'Archived',
  showAllJobs: 'Show all jobs',
  addNewCandidate: 'Add new candidate',
  startTypingNameOrEmailOrTag: 'Search candidate name or email (min {length} chars)',
  countOfSelected: '{count} of {total} selected',
  selectAll: 'Select top 500 | Select all {count}',
  changeOriginAndSource: 'Change origin and source | Change origin and source ({count})',
  addTags: 'Add tags | Add tags ({count})',
  changeCandidateOwner: 'Change candidate owner | Change candidate owner ({count})',
  removeTags: 'Remove tags | Remove tags ({count})',
  moveCandidateToAnotherJob: 'Move candidates to another job ({count})',
  sendEmail: 'Send email',
  deleteApplications: 'Delete applications',
  archiveApplications: 'Archive applications',
  unArchiveApplications: 'Unarchive applications ({count}) | Unarchiving...',
  insteadAddTags: 'Instead add tags',
  insteadRemoveTags: 'Instead remove tags',
  frequentUsedTags: 'Frequently used tags',
  progressToNextStage: 'Progress to next stage',
  deleteApplication: 'Delete one application | Delete {count} applications',
  deleteApplicationNote: 'This action will delete the selected candidate applications. This action cannot be undone. Are you sure?',
  triggerEmailNote: 'This action might trigger an email to candidates if rejection automations are enabled.',
  archiveApplication: 'Archive candidate application ({count})',
  progressStage: 'Progress stage ({count})?',
  progressStageConfirmation: 'This action will progress the selected candidate to the {name} stage. Are you sure?',
  progressStageNote: 'Note: This will send an email to candidates if stage welcome mail is enabled.',
  selectedOutOf: '{selected} applications out of {total} are in same stage',
  progressLoading: 'Progress stage ({count}) | Progressing stage...',
  sendEmailTo: 'Send email ({to})',
  archivingAs: 'Archiving as {reason} ({count})',
  mailsAddedOutOf: '{count} applications out of {total} do not have emails added to their profile',
  clearSelection: 'Clear selection',
  sendEmailToUsersNote: 'This will send an email to all {count} candidates who have emails added to their profiles.',
  noCandidatesFound: 'No candidates found 🙂',
  noCandidatesFoundTitle: 'No candidates found',
  noCandidatesFoundDescription: 'All the candidates applied and added will show up here!',
  placeHolders: {
    searchByJobTitle: 'Search by job title | Jobs selected({count})',
    jobMatch: 'Job match | Job match({count})',
    status: 'Status| Status({count})',
    archivalReasons: 'Archival reason | Archival reason({count})',
    origin: 'Origin | Origin({count})',
    source: 'Source | Source({count})',
    owners: 'Owners | Owners({count})',
    tag: 'Tag | Tag({count})',
    tagInput: 'Enter new or existing tags',
    selectOwner: 'Select owner',
    selectJob: 'Select job',
    selectStage: 'Select stage',
    tagRemoveInput: 'Select existing tags',
    selectOrigin: 'Select origin',
    enterSource: 'Enter source',
    selectArchivalReason: 'Select archival reason',
    sourcedBy: 'Sourced by | Sourced by({count})',
    referredBy: 'Referred by | Referred by({count})',
    agency: 'Agency | Agency({count})'
  },
  filtersDialogPlaceHolders: {
    jobMatch: 'Select job match | Select job match({count})',
    status: 'Select status | Select status({count})',
    archivalReasons: 'Select archival reason | Select archival reason({count})',
    origin: 'Select origin | Select origin({count})',
    source: 'Select source | Select source({count})',
    owners: 'Select owners | Select owners({count})',
    tag: 'Select tags | Select tags({count})',
    sourcedBy: 'Select sourced by | Select sourced by({count})',
    referredBy: 'Select referred by | Select referred by({count})',
    agency: 'Select agency | Select agency({count})'
  },
  filters: {
    origin: 'Origin',
    source: 'Source',
    statuses: 'Status'
  },
  table: {
    header: {
      name: 'NAME',
      candidateOwner: '',
      jobAndStage: 'JOB & STAGE',
      multipleApplications: '',
      jobMatch: 'JOB MATCH',
      activity: 'LATEST ACTIVITY | ARCHIVAL REASON',
      lastActivity: 'UPDATED'
    }
  },
  warnings: {
    bulkArchivalPrefix: 'Bulk archival with job id {part}',
    bulkProgressPrefix: 'Bulk progress with job id {part}',
    bulkEmailsPrefix: 'Bulk emails with job id {part}',
    bulkUnArchivalPrefix: 'Bulk unarchival with job id {part}',
    bulkTags: 'Bulk tags with job id {part}',
    bulkQueued: '{prefix} is queued. We will notify you after completion'
  },
  errors: {
    pleaseInputSource: 'Please input source',
    pleaseInputTags: 'Please enter new or existing tags',
    pleaseSelectOwner: 'Please select owner',
    pleaseInputOrigin: 'Please select origin',
    pleaseInputArchiveReason: 'Please select archive reason',
    pleaseSelectJob: 'Please select job',
    pleaseSelectStage: 'Please select stage'
  },
  successMessages: {
    sourceOriginChanged: 'Source and origin changed successfully',
    addTags: 'Tags added successfully',
    removeTags: 'Tags removed successfully',
    applicationDeleted: 'Applications deleted successfully',
    archivedApplication: 'Archived the applications successfully',
    unarchivedApplications: 'Unarchived the applications successfully',
    progressed: 'Progressed candidates successfully',
    emailsSent: 'Emails are sent successfully',
    successMessages: 'Files added successfully',
    filesAdded: 'Files added successfully',
    notesAdded: 'Notes added successfully',
    jobChanged: 'Job changed successfully'
  },
  cvSearchDialog: {
    title: 'Search your CV database',
    subTitle: 'Find CVs that',
    addSearchTerm: 'Add search term',
    matchingCandidates: 'Matching candidates: ',
    filters: {
      includesAll: 'Includes all of',
      includesAny: 'Includes any of'
    }
  },
  cvSearch: 'CV search',
  latestActivity: {
    offerSent: 'Offer sent by {recruiterName} on {date}',
    offerAccepted: 'Offer accepted by {candidateName} on {date}',
    offerRejected: 'Offer rejected by {candidateName} on {date}',
    offerSentOn: 'Offer sent on',
    offerAcceptedOn: 'Offer accepted on',
    offerRejectedOn: 'Offer rejected on'
  },
  addAtleastOneSearchTerm: 'Add at least one search term',
  lastActive: 'Last active {text}',
  advancedFilters: 'Advanced filters',
  keywords: 'Keywords',
  tags: 'Tags',
  candidateTaskStatus: 'Candidate task status',
  candidateTaskOwner: 'Candidate task owner',
  jobMatch: 'Job match',
  archivalReasons: 'Archival reasons',
  origin: 'Origin',
  source: 'Source',
  applyFilters: 'Apply filters',
  clearAllCount: 'Clear all ({count})',
  noMatchingData: 'No matching data',
  noDataFound: 'No data found',
  enterAtLeast2Characters: 'Please enter at least 2 characters',
  noMore: 'No more',
  skills: 'Skills',
  searchByTitle: 'Search by {title}',
  candidateListFilterType: {
    SKILLS: 'skills',
    INDUSTRY: 'industry',
    LANGUAGES: 'languages',
    MOTHER_TONGUE: 'mother tongue',
    GENDER: 'gender',
    MARITAL_STATUS: 'marital status',
    EMPLOYER: 'employer',
    JOB_TITLE: 'job title',
    EDUCATION_INSTITUTION: 'education institution',
    EDUCATION_DEGREE: 'education degree',
    EDUCATION_FIELD_OF_STUDY: 'education field of study',
    HOBBIES: 'hobbies',
    KEYWORDS: 'other keywords',
    COUNTRY: 'country',
    CITY: 'city',
    NATIONALITY: 'nationality'
  },
  groupBy: 'group by | Group by',
  appliedJobsCount: 'Selected jobs ({count})',
  clearAll: 'Clear all',
  clearAppliedJobs: 'Clear selected jobs',
  selectAllJobs: 'Select all',
  clearFilters: 'Clear filters',
  bulkCandidateSelfSchedule: 'Bulk candidate self schedule',
  exportToCSV: 'Export to CSV',
  showCandidates: 'Show candidates',
  includeUnspecifiedGender: 'Include candidates who did not specify gender in their CV',
  includeUnspecifiedNationality: 'Include candidates who did not specify nationality in their CV',
  showCurrentEmployedOnly: 'Show candidates currently working with these employers',
  includeUnspecifiedLanguages: 'Include candidates who did not specify languages in their CV',
  generateScore: 'Generate score',
  generateScoreTooltip: 'Bulk score CVs',
  parseCVs: 'Parse CVs',
  parseCVsTooltip: 'Bulk parse CVs',
  selectUnParsedCandidates: 'Show only candidates who are Not Parsed',
  selectUnParsedCandidatesTooltip: 'Only candidates whose CVs are \'Not Parsed\' will be shown. Other AI filters cannot be applied when this filter is selected',
  sourcedBy: 'Sourced by',
  referredBy: 'Referred by',
  agency: 'Agency',
  applicationDate: 'Application date',
  selectApplicationBetweenDates: 'Select application between dates',
  lastActivityDate: 'Last activity date',
  selectLastActivityBetweenDates: 'Select last activity between dates',
  bulkNotes: {
    addComment: 'Add comment | Add comment ({count})',
    addNoteHere: 'Add note here',
    areYouSureToAddNotes: 'Are you sure to add notes for {count} candidates?',
    confirmationForAdding: 'Confirmation for adding notes in bulk'
  },
  bulkOwner: {
    chooseOwner: 'Choose the owner',
    confirmationForBulkOwnerChange: 'Confirmation for bulk owner change',
    areYouSureToChangeOwner: 'Are you sure to change owner for {count} candidates?',
    yesChange: 'Yes change',
    ownerChangedSuccessfully: 'Owner changed successfully'
  }
}

export const CandidateListArabic = {
  title: 'المرشحون',
  published: 'تم النشر',
  closed: 'مغلق',
  activeCount: 'نشط',
  archiveCount: 'تم الأرشفة',
  showAllJobs: 'عرض جميع الوظائف',
  addNewCandidate: 'أضف مرشح جديد',
  startTypingNameOrEmailOrTag: 'ابحث عن اسم المرشح أو البريد الإلكتروني (الحد الأدنى {length} أحرف)',
  countOfSelected: '{count} من {total} محددين',
  selectAll: 'اختر أعلى 500 | اختر الكل {count}',
  changeOriginAndSource: 'تغيير المصدر والأصل | تغيير المصدر والأصل ({count})',
  changeCandidateOwner: 'تغيير مالك المرشح | تغيير مالك المرشح ({count})',
  addTags: 'أضف العلامات | اضف اشارة ({count})',
  removeTags: 'إزالة العلامات | إزالة العلامات ({count})',
  moveCandidateToAnotherJob: 'نقل المرشحين إلى وظيفة أخرى ({count})',
  insteadAddTags: 'بدلا من ذلك أضف العلامات',
  insteadRemoveTags: 'بدلا من ذلك قم بإزالة العلامات',
  frequentUsedTags: 'العلامات المستخدمة بشكل متكرر',
  progressToNextStage: 'انتقل إلى المرحلة التالية',
  deleteApplication: 'حذف طلب توظيف واحد | حذف {count} طلب',
  deleteApplicationNote: 'سيحذف هذا الإجراء طلبات توظيف المرشحين المحددين، ولا يمكن التراجع عنه. هل تريد المتابعة؟',
  triggerEmailNote: 'يؤدي هذا الإجراء إلى إرسال ايميلات رفض للمرشحين إذا تم تفعيل إرسال ايميلات الرفض التلقائية.',
  archiveApplication: 'أرشفة طلب توظيف المرشح ({count})',
  progressStage: 'تقدم المرحلة ({count})؟',
  progressStageConfirmation: 'سينقل هذا الإجراء المرشح المحدد إلى مرحلة {name}. هل تريد المتابعة؟',
  progressStageNote: 'ملاحظة: يؤدي هذا الإجراء إلى إرسال ايميلات ترحيب بالمرشح في المرحلة الجديدة من عملية التوظيف، إذا تم تفعيل إرسال ايميلات الترحيب التلقائية.',
  selectedOutOf: '{selected} طلب/طلبات توظيف من أصل {total} طلب توظيف في نفس المرحلة',
  progressLoading: 'تقدم المرحلة ({count}) | يتم التقدم في المرحلة...',
  sendEmailTo: 'أرسل ايميل ({to})',
  archivingAs: 'الأرشفة بسبب {reason} ({count})',
  mailsAddedOutOf: '{count} طلب/طلبات توظيف من أصل {total} طلب توظيف لا تحتوي على ايميل في ملفهم الشخصي',
  clearSelection: 'مسح التحديد',
  noCandidatesFound: 'لم يتم العثور على مرشحين 🙂',
  noCandidatesFoundTitle: 'لم يتم العثور على مرشحين',
  noCandidatesFoundDescription: 'جميع المرشحين الذين تقدموا بطلب وتم إضافتهم سيظهرون هنا!',
  owners: 'المالكين',
  placeHolders: {
    searchByJobTitle: 'البحث بالمسمى الوظيفي',
    jobMatch: 'تطابق الوظيفة | تطابق الوظيفة ({count})',
    status: 'الحالة | الحالة({count})',
    archivalReasons: 'سبب الأرشفة | سبب الأرشفة({count})',
    origin: 'المصدر | المصدر({count})',
    source: 'المورد | المورد({count})',
    selectOwner: 'اختر المالك',
    owners: 'المالكين | المالكين ({count})',
    tag: 'كلمة مميزة | كلمة مميزة({count})',
    tagInput: 'أدخل علامات جديدة أو موجودة',
    selectJob: 'اختر وظيفة',
    selectStage: 'اختر مرحلة',
    tagRemoveInput: 'حدد العلامات الموجودة',
    selectOrigin: 'اختر المصدر',
    enterSource: 'اختر المورد',
    selectArchivalReason: 'اختر سبب الأرشفة',
    sourcedBy: 'تم التوريد من قبل | تم التوريد من قبل({count})',
    referredBy: 'تم الإحالة من قبل | تم الإحالة من قبل({count})',
    agency: 'الوكالة | الوكالة({count})'
  },
  filtersDialogPlaceHolders: {
    jobMatch: 'اختر توافق الوظيفة | اختر توافق الوظيفة ({count})',
    status: 'اختر الحالة | اختر الحالة ({count})',
    archivalReasons: 'اختر سبب الأرشفة | اختر سبب الأرشفة ({count})',
    origin: 'اختر الأصل | اختر الأصل ({count})',
    source: 'اختر المصدر | اختر المصدر ({count})',
    owners: 'اختر المالكين | اختر المالكين ({count})',
    tag: 'اختر العلامات | اختر العلامات ({count})',
    sourcedBy: 'اختر من قام بالتوريد | اختر من قام بالتوريد({count})',
    referredBy: 'اختر من قام بالإحالة | اختر من قام بالإحالة({count})',
    agency: 'اختر الوكالة | اختر الوكالة({count})'
  },
  filters: {
    origin: 'المصدر',
    source: 'المورد',
    statuses: 'الحالات'
  },
  table: {
    header: {
      name: 'الاسم',
      candidateOwner: '',
      jobAndStage: 'الوظيفة والمرحلة',
      multipleApplications: '',
      jobMatch: 'تطابق الوظيفة',
      activity: 'آخر نشاط | سبب الأرشفة',
      lastActivity: 'آخر نشاط'
    }
  },
  warnings: {
    bulkArchivalPrefix: 'أرشفة مجمعة باستخدام معرف الوظيفة {part}',
    bulkProgressPrefix: 'انتقال مجمع للمرحلة التالية باستخدام معرف الوظيفة {part}',
    bulkEmailsPrefix: 'إرسال مجموعة ايميلات تلقائيًا باستخدام معرف الوظيفة {part}',
    bulkTags: '{part} العلامات المجمعة مع معرف الوظيفة',
    mailsAddedOutOf: 'تمت إضافة البريد الإلكتروني لدى {count} طلبًا من أصل {total} والذين لا يحتوون على عناوين بريد إلكتروني في ملفاتهم الشخصية',
    sendEmailTo: 'لا يحتوون على عناوين بريد إلكتروني في ملفاتهم الشخصية',
    bulkQueued: '{prefix} في قائمة الانتظار. سنخطرك بعد الإتمام'
  },
  errors: {
    pleaseInputSource: 'رجاءً ادخل المورد',
    pleaseInputOrigin: 'رجاءً ادخل المصدر',
    pleaseInputTags: 'الرجاء إدخال علامات جديدة أو موجودة',
    pleaseInputArchiveReason: 'يرجى اختيار سبب الأرشفة',
    pleaseSelectJob: 'يرجى اختيار الوظيفة',
    pleaseSelectStage: 'يرجى اختيار المرحلة',
    pleaseSelectOwner: 'يرجى اختيار المالك'
  },
  successMessages: {
    sourceOriginChanged: 'تم تغيير المصدر والمورد بنجاح',
    applicationDeleted: 'تم حذف طلبات التوظيف بنجاح',
    addTags: 'تمت إضافة العلامات بنجاح',
    removeTags: 'تمت إزالة العلامات بنجاح',
    archivedApplication: 'تم أرشفة طلبات التوظيف بنجاح',
    progressed: 'تم نقل المرشحين إلى المرحلة التالية بنجاح',
    emailsSent: 'تم إرسال الايميلات بنجاح',
    successMessages: 'تم إضافة الملفات بنجاح',
    filesAdded: 'تمت إضافة الملفات بنجاح',
    notesAdded: 'تمت إضافة الملاحظات بنجاح',
    jobChanged: 'تم تغيير الوظيفة بنجاح'
  },
  cvSearchDialog: {
    title: 'ابحث في قاعدة بيانات سيرتك الذاتية',
    subTitle: 'ابحث عن السير الذاتية التي',
    addSearchTerm: 'إضافة مصطلح بحث',
    matchingCandidates: 'المرشحون المطابقون: ',
    filters: {
      includesAll: 'يشمل جميع',
      includesAny: 'يشمل أي من'
    }
  },
  cvSearch: 'بحث السيرة الذاتية',
  latestActivity: {
    offerSent: 'تم إرسال العرض من قبل {recruiterName} في {date}',
    offerAccepted: 'تم قبول العرض من قبل {candidateName} في {date}',
    offerRejected: 'تم رفض العرض من قبل {candidateName} في {date}',
    offerSentOn: 'تم إرسال العرض في',
    offerAcceptedOn: 'تم قبول العرض في',
    offerRejectedOn: 'تم رفض العرض في'
  },
  addAtleastOneSearchTerm: 'أضف مصطلح بحث واحد على الأقل',
  lastActive: 'آخر نشاط منذ {count} أيام',
  applyFilters: 'تطبيق الفلاتر',
  clearAllCount: 'مسح الكل ({count})',
  noMatchingData: 'لا توجد بيانات مطابقة',
  noDataFound: 'لم يتم العثور على بيانات',
  enterAtLeast2Characters: 'يرجى إدخال حرفين على الأقل',
  noMore: 'لا يوجد المزيد',
  skills: 'المهارات',
  searchByTitle: 'ابحث بواسطة {title}',
  candidateListFilterType: {
    SKILLS: 'المهارات',
    INDUSTRY: 'الصناعة',
    LANGUAGES: 'اللغات',
    MOTHER_TONGUE: 'اللغة الأم',
    GENDER: 'الجنس',
    MARITAL_STATUS: 'الحالة الاجتماعية',
    EMPLOYER: 'صاحب العمل',
    JOB_TITLE: 'المسمى الوظيفي',
    EDUCATION_INSTITUTION: 'المؤسسة التعليمية',
    EDUCATION_DEGREE: 'الدرجة التعليمية',
    EDUCATION_FIELD_OF_STUDY: 'مجال الدراسة',
    HOBBIES: 'الهوايات',
    KEYWORDS: 'الكلمات الرئيسية',
    COUNTRY: 'الدولة',
    CITY: 'المدينة',
    NATIONALITY: 'الجنسية'
  },
  groupBy: 'تجميع حسب | تجميع حسب',
  appliedJobsCount: 'وظائف مختارة (عدد)',
  clearAll: 'مسح الكل',
  clearAppliedJobs: 'مسح الوظائف المحددة',
  selectAllJobs: 'تحديد الكل',
  clearFilters: 'مسح الفلاتر',
  bulkCandidateSelfSchedule: 'جدولة ذاتية جماعية للمرشحين',
  exportToCSV: 'تصدير إلى CSV',
  showCandidates: 'عرض المرشحين',
  includeUnspecifiedGender: 'تضمين المرشحين الذين لم يحددوا الجنس في سيرتهم الذاتية',
  includeUnspecifiedNationality: 'تضمين المرشحين الذين لم يحددوا الجنسية في سيرتهم الذاتية',
  showCurrentEmployedOnly: 'عرض المرشحين الذين يعملون حاليًا مع هؤلاء أصحاب العمل',
  includeUnspecifiedLanguages: 'تضمين المرشحين الذين لم يحددوا اللغات في سيرتهم الذاتية',
  generateScore: 'توليد التقييم',
  generateScoreTooltip: 'توليد التقييم للمئات من السير الذاتية',
  parseCVs: 'تحليل السير الذاتية',
  parseCVsTooltip: 'تحليل المئات من السير الذاتية',
  selectUnParsedCandidates: 'اختيار المرشحين ذوي السير الذاتية غير المحللة في البحث',
  jobMatch: 'تطابق الوظيفة',
  candidateTaskStatus: 'حالة مهمة المرشح',
  candidateTaskOwner: 'مالك مهمة المرشح',
  sourcedBy: 'تم التوريد من قبل',
  referredBy: 'تم الإحالة من قبل',
  agency: 'الوكالة',
  applicationDate: 'تاريخ التقديم',
  lastActivityDate: 'تاريخ آخر نشاط',
  bulkNotes: {
    addComment: 'إضافة تعليق | إضافة تعليق ({count})',
    addNoteHere: 'أضف ملاحظة هنا',
    areYouSureToAddNotes: 'هل أنت متأكد من إضافة الملاحظات لـ {count} من المرشحين؟',
    confirmationForAdding: 'تأكيد لإضافة الملاحظات بشكل جماعي'
  },
  bulkOwner: {
    chooseOwner: 'اختر المالك',
    confirmationForBulkOwnerChange: 'تأكيد لتغيير المالك الجماعي',
    areYouSureToChangeOwner: 'هل أنت متأكد من تغيير المالك لـ {count} من المرشحين؟',
    yesChange: 'نعم، قم بالتغيير',
    ownerChangedSuccessfully: 'تم تغيير المالك بنجاح'
  }
}
